import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { WS } from './utils/cust_websocket'
import { http } from './utils/requert'
import './assets/icon/iconfont.css'
import './assets/css/index.less'
import Vconsole from 'vconsole'

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
const config = {
  baseURL: process.env.VUE_APP_BASE_API,
  wsURL: process.env.VUE_APP_BASE_WS
}
if (process.env.VUE_APP_OPEN_VCONSOLE === 'true') {
  // const vConsole = new Vconsole();
}
let ws = new WS()
app.config.globalProperties.$ws = ws
app.config.globalProperties.$http = http
app.config.globalProperties.$config = config
app.mount('#app')
